import { Action } from '@ngrx/store';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel } from "../../shared/interfaces/CriteriaModel";

export enum ActionTypes {
	GetBanners = 'GetBanners',
	GetBannersSuccess = 'GetBannersSuccess',
	GetBannersError = 'GetBannersError',

	GetBannersForProduct = 'GetBannersForProduct',
	GetBannersForProductSuccess = 'GetBannersForProductSuccess',
	GetBannersForProductError = 'GetBannersForProductError',

	GetBannersForStore = 'GetBannersForStore',
	GetBannersForStoreSuccess = 'GetBannersForStoreSuccess',
	GetBannersForStoreError = 'GetBannersForStoreError',

	GetPopularJewellers = 'GetPopularJewellers',
	GetPopularJewellersSuccess = 'GetPopularJewellersSuccess',
	GetPopularJewellersError = 'GetPopularJewellersError',
}

export class GetBanners implements Action {
	readonly type = ActionTypes.GetBanners;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetBannersSuccess implements Action {
	readonly type = ActionTypes.GetBannersSuccess;

	constructor(public payload: any) {
	}
}

export class GetBannersError implements Action {
	readonly type = ActionTypes.GetBannersError;

	constructor(public payload: AusmitError) {
	}
}

export class GetBannersForProduct implements Action {
	readonly type = ActionTypes.GetBannersForProduct;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetBannersForProductSuccess implements Action {
	readonly type = ActionTypes.GetBannersForProductSuccess;

	constructor(public payload: any) {
	}
}

export class GetBannersForProductError implements Action {
	readonly type = ActionTypes.GetBannersForProductError;

	constructor(public payload: AusmitError) {
	}
}

export class GetBannersForStore implements Action {
	readonly type = ActionTypes.GetBannersForStore;

	constructor(public payload: CriteriaModel) {
	}
}

export class GetBannersForStoreSuccess implements Action {
	readonly type = ActionTypes.GetBannersForStoreSuccess;

	constructor(public payload: any) {
	}
}

export class GetBannersForStoreError implements Action {
	readonly type = ActionTypes.GetBannersForStoreError;

	constructor(public payload: AusmitError) {
	}
}

export class GetPopularJewellers implements Action {
	readonly type = ActionTypes.GetPopularJewellers;

	constructor(public payload: { city: string }) {
	}
}

export class GetPopularJewellersSuccess implements Action {
	readonly type = ActionTypes.GetPopularJewellersSuccess;

	constructor(public payload: any) {
	}
}

export class GetPopularJewellersError implements Action {
	readonly type = ActionTypes.GetPopularJewellersError;

	constructor(public payload: AusmitError) {
	}
}

export type Actions =
	| GetBanners
	| GetBannersSuccess
	| GetBannersError
	| GetPopularJewellers
	| GetPopularJewellersSuccess
	| GetPopularJewellersError
	| GetBannersForProduct
	| GetBannersForProductSuccess
	| GetBannersForProductError
	| GetBannersForStore
	| GetBannersForStoreSuccess
	| GetBannersForStoreError;

